import { createFileRoute } from "@tanstack/react-router";
import { marketingHead } from "../marketing-content/head";

import { MarketingLegalPage } from "../components/marketing/MarketingLegalPage";
import { termsDocument } from "../components/marketing/legalDocuments";

export const Route = createFileRoute("/terms")({
  head: () => marketingHead("/terms"),
  component: () => <MarketingLegalPage document={termsDocument} />,
});
